<template>
    <input type="text" :id="id" :name="name" :value="modelValue" @blur="$emit('update:modelValue', $event.target.value)" :class="className" :placeholder="placeholder" :title="title" autocomplete="off">
</template>

<script>
    export default {
        name: 'DateRangePicker',
        props: {
            modelValue: {},
            id: {default: ''},
            name: {default: ''},
            placeholder: {default: ''},
            title: {default: ''},
            className: {default: 'form-control'},
            format: {
                type: String,
                default: "YYYY-MM-DD"
            },
            isSingle:{
                default: false
            },
            minDate: {},
            maxDate: {},
            options: {},
        },
        mounted() {

            this.$nextTick(() => {
                const el = $(this.$el);

                el.daterangepicker({
                    locale: {
                        format: this.format,
                        cancelLabel: 'Clear'
                    },
                    autoclose: true,
                    clearBtn: true,
                    autoUpdateInput: false,
                    minDate: this.minDate,
                    maxDate: this.maxDate,
                    singleDatePicker: this.isSingle,
                    ...this.options,
                });

                el.on("apply.daterangepicker", (event, picker) => {
                    const startDate = picker.startDate.format(this.format);
                    const endDate = picker.endDate.format(this.format);
                    if (this.isSingle) {
                        this.$emit("update:modelValue", startDate);
                    } else {
                        this.$emit("update:modelValue", startDate + " / " + endDate);
                    }
                });
                el.on("cancel.daterangepicker", () => {
                    this.$emit("update:modelValue", '');
                });

                $(".cancelBtn").removeClass("btn-default").addClass("btn btn-sm btn-danger");
                $(".applyBtn").addClass("btn btn-sm btn-primary");
            });

        },
        beforeUnmount() {
            $(this.$el).daterangepicker("hide").daterangepicker("destroy");
        }
    };
</script>
